import { Routes } from '@angular/router';
import { Menu } from './components/navigation/menu/menu';
import { NotFoundPage } from './components/navigation/not-found-page/not-found-page';
import { ValidationGrid } from './components/validation/validation-grid/validation-grid';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    loadComponent: () => import('./components/navigation/menu/menu').then(m => m.Menu),
    children: [
      {
        path: '',
        redirectTo: 'validations',
        pathMatch: 'full'
      },
      {
        path: 'validations',
        canActivate: [MsalGuard],
        loadComponent: () => import('./components/validation/validation-grid/validation-grid').then(m => m.ValidationGrid),
        data: { title: 'Validations List' }
      },
      {
        path: 'validations/details/:id',
        canActivate: [MsalGuard],
        loadComponent: () => import('./components/validation/validation-details/validation-details').then(m => m.ValidationDetails),
        data: { title: 'Validation Details' }
      },
      {
        path: '**',
        component: NotFoundPage,
        data: { title: 'Page Not Found' },
      },
    ]
  },
];
